import { render, staticRenderFns } from "./Page1Chart1.vue?vue&type=template&id=4cf473d4&scoped=true&"
import script from "./Page1Chart1.vue?vue&type=script&lang=ts&"
export * from "./Page1Chart1.vue?vue&type=script&lang=ts&"
import style0 from "./Page1Chart1.vue?vue&type=style&index=0&id=4cf473d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cf473d4",
  null
  
)

export default component.exports